/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorConsequenceModel } from '../../models/patient-behavior-consequence-model';

export interface GetPatientBehaviorConsequences$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetPatientBehaviorConsequences(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorConsequences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorConsequenceModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorConsequences.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorConsequenceModel>>;
    })
  );
}

GetPatientBehaviorConsequences.PATH = '/api/Staff/GetPatientBehaviorConsequences';
